import * as types from '@/store/mutationTypes';
import sessionManager from '@/store/modules/session/sessionManager';
import stbAPIGateway from '../../../services/stbAPIGateway';

export default {
  async init({ commit }, axiosInstance) {
    const xClientSubdomain = sessionManager.getClientSubdomain();
    sessionManager.setClientSubdomainHeaders(axiosInstance, xClientSubdomain);
    commit(types.SET_TOKEN_EXPIRY_IN_MS, sessionManager.getTokenExpiryInMS());
    commit(types.SET_TOKEN, sessionManager.getAuthTokenFromCookie());
    commit(types.SET_SESSION_READY, true);
  },
  async handleLoginCallback({ commit }) {
    const locationHash = window.location.hash;
    if (locationHash.indexOf('access_token=') > -1) {
      const token = locationHash.split('access_token=')[1].split('&')[0];
      if (token) {
        if (process.env.APP_ENV !== 'automation') {
          try {
            window.gtag('event', 'login', { method: 'cs_idp' });
          } catch (err) {
            console.log('Login event not fired');
          }
        }
        sessionManager.saveAuthTokenToCookie(token);
        commit(types.SET_TOKEN_EXPIRY_IN_MS, sessionManager.getTokenExpiryInMS());
        commit(types.SET_TOKEN, token);
      }
    }
  },
  // this action is a prelogout action that will be called in CSDS before the user is logged out
  // it will delete the user info cache from the STB API, updating it might cause userInfo cache to remain in STB API after logging out
  async handlePreLogoutEvent({ rootGetters }) {
    const axios = rootGetters['app/stbAxios'];
    try {
      const stbApi = stbAPIGateway(axios, process.env.API_URL);
      const response = await stbApi.logoutUser();
      return response;
    } catch (error) {
      console.error('Error deleting user info cache', error);
      return null;
    }
  },

  async logout({ commit, rootState, rootGetters }, query) {
    const axios = rootGetters['app/stbAxios'];
    const token = sessionManager.getAuthTokenFromCookie();

    if (token) {
      const stbApi = stbAPIGateway(axios, process.env.API_URL);
      await stbApi.logoutLegacyIdpUser();
    }

    sessionManager.removeAuthTokenFromCookie();
    commit(types.SET_TOKEN_EXPIRY_IN_MS, 0);
    commit(types.SET_TOKEN, null);
    if (!token || !query?.referrer) {
      const idpUrl = rootState?.session?.idpUrl;
      if (idpUrl) {
        localStorage.setItem('idp_redirect', '');
        window.location.href = `${idpUrl}/signout`;
        return;
      }
      localStorage.setItem('idp_redirect', window.location.pathname);
      const queryString = query
        ? '?' +
          Object.entries(query)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&')
        : '';
      window.location.href = `/login${queryString}`;
    } else {
      commit(types.AUTHORISATION_SET_IS_AUTHENTICATED, false, { root: true });
      commit(types.AUTHORISATION_SET_IS_INIT_CLIENT_CONFIG_IN_PROGRESS, false, { root: true });
    }
  }
};
